import React from 'react' // eslint-disable-line

import styled from 'styled-components'
import SALink from 'components/SALink'
import { Button } from 'styles/algolia/button'
import { OwnerInfoSection as OwnerInfo } from 'styles/algolia/user/header'
import { Column, Row } from 'styles/general'
export const InfoRow = styled(Row)`
  margin-bottom: 25px;
`
export const InfoColumn = styled(Column)``
export const ArtistName = styled.h1`
  margin-top: 0;
  font-size: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 58px;
`
export const FilterButton = styled(Button)`
  ${(props) =>
    props.isOpen &&
    `
    background: ${props.theme.colors.default};
    opacity: 1;
    color: ${props.theme.colors.white};
    svg {
      fill: white;
    }
  `}
`
export const FilterButtonRow = styled(Row)`
  margin-top: 25px;
  @media (max-width: ${(props) => props.theme.breakpoints[0]}) {
    margin-top: 0;
  }
`
export const BackToProfile = styled(SALink)`
  font-size: 12px;
  color: ${(props) => props.theme.colors.default};
  text-decoration: none;
  font-weight: bold;
  svg {
    margin-right: 6px;
    margin-left: 2px;
    height: 9.5px;
    path {
      stroke: ${(props) => props.theme.colors.default};
      fill: ${(props) => props.theme.colors.default};
    }
  }
`
export const NavLink = styled(SALink)`
  text-decoration: none;
  background-color: ${(props) => props.theme.colors.backgroundGray};
  color: ${(props) => props.theme.colors.default};
  font-size: 18px;
  font-weight: bold;
  margin-right: 20px;
  padding: 14px 20px 14px;
  min-width: 327px;
  width: 33%;
  display: flex;
  height: 48px;
  &[data-type='collections'] {
    background-color: ${(props) => props.theme.colors.default};
    color: ${(props) => props.theme.colors.white};
  }
  &:last-child {
    margin-right: 0;
  }
  @media (max-width: ${(props) => props.theme.breakpoints[0]}) {
    width: 100%;
    margin-bottom: 10px;
    align-self: flex-start;
    min-width: initial;
  }
`
export const OwnerInfoSection = styled(OwnerInfo)`
  &&& ${InfoRow} {
    @media (max-width: ${(props) => props.theme.breakpoints[0]}) {
      flex-direction: column;
      align-items: flex-start;
    }
  }
`
export const FeedViewSwitcher = styled.div`
  font-weight: bold;
  cursor: pointer;
  background-color: ${(props) => props.theme.colors.backgroundGray};
  text-align: center;
  width: 150px;
  padding: ${(props) => props.theme.space[3]}px;
  ${(props) =>
    props.selected &&
    `background: ${props.theme.colors.default}; color: ${props.theme.colors.white}`};
  :hover {
    background-color: ${(props) => !props.selected && props.theme.colors.backgroundMediumGray};
  }
  @media (max-width: ${(props) => props.theme.breakpoints[0]}) {
    width: 43%;
  }
`
export const ActionsLinks = styled(Row)`
  justify-content: flex-start;
  padding-bottom: 15px;
  ${Row} {
    margin-top: 20px;
    justify-content: flex-start;
    span {
      margin-right: 10px;
    }
  }
  @media (min-width: ${(props) => props.theme.breakpoints[1]}) {
    margin-top: 0;
  }
`
export const ViewToggle = styled(Row)`
  margin-bottom: 20px;
  overflow: hidden;
  max-width: 350px;
  ${Button} {
    background-color: #f3f3f3;
    width: 150px;
    height: 48px;
    flex: 1;
    margin: 0;
    border: none;
    transition: 0.2s ease-in-out opacity;
    font-weight: bold;
    font-size: 16px;
    &:hover {
      border: none;
    }
  }
  [data-type='${(props) => props.type}'] {
    background: ${(props) => props.theme.colors.default};
    color: ${(props) => props.theme.colors.white};
    border: none;
    &:hover {
      background: ${(props) => props.theme.colors.default};
      color: ${(props) => props.theme.colors.white};
    }
  }
  ${Row} {
  width: initial;
  margin-top: 20px;
  }
  span {
  margin-right: 10px;
  }
`
export { Row }
